import type { ConfigClient } from "./ConfigClient";
import {
  trackConfigCreated,
  trackConfigUpdated,
  trackConfigDeleted,
} from "../analytics/tracking";

/* Wraps a ConfigClient so config lifecycle analytics fire at the client layer.
 * The spec calls for this explicitly: hooking create/update/remove here means
 * config changes made via the agent-create copy-config flow and the agent-
 * delete cascade fire too, not just the ConfigEditor. Read-only methods pass
 * straight through. */
export function withConfigTracking(client: ConfigClient): ConfigClient {
  return {
    list: () => client.list(),
    get: (configId) => client.get(configId),
    getSchema: () => client.getSchema(),

    async create(payload) {
      const config = await client.create(payload);
      trackConfigCreated(config.config_id);
      return config;
    },

    async update(configId, payload) {
      const config = await client.update(configId, payload);
      trackConfigUpdated(config.config_id);
      return config;
    },

    async remove(configId) {
      await client.remove(configId);
      trackConfigDeleted(configId);
    },
  };
}
